
export function HeroSection() {
    return (
        <section
            className="relative w-full max-w-4xl p-6 text-center flex flex-col items-center justify-center min-h-[500px]"
            aria-label="Daisy Kirbukas peamine sektsioon"
        >



            <header className="relative z-10 text-white" style={{ textShadow: "0 2px 4px rgba(0,0,0,0.3)" }}>
                <h1 className="text-4xl font-bold mb-4 sr-only">Oleme kahjuks suletud.</h1>
                <p className="text-lg mb-6 max-w-lg mx-auto font-serif font-semibold text-xl">
                    Oleme kahjuks suletud.
                </p>
            </header>
        </section>
    );
}
